export default {"src":"/_next/static/image/public/images/flags/flag_1340.ba7a14c1c89210ebda248c1ac50c0dbc.svg","height":16,"width":24};